import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteTicket } from "../../api/TICKET/ticket";
import { useNavigate } from "react-router-dom";

export function useDeleteTicket() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (id) => deleteTicket(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tickets"] });
      navigate("/tickets");
    },
  });
}